import React, { Component } from "react";
import { DatePicker, Spin, message, Checkbox } from "antd";
import Bridge from "../../../utils/Bridge";
import { speech_demographics_form_type } from "../../../utils/consts";
import moment from "moment";
import dayjs from "dayjs";

export default class SymptomOnsetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date_of_symptom_onset: null,
      gender:"",
      loading: false,
      email:"",
      neurostamp_id:"",
      modality_id:"",
      question_list:[],
      field_data:[],

      generalized:false,
      bulbar:false,
      bulbar_speech:false,
      bulbar_swallowing:false,

      axial:false,
      neck:false,
      trunk:false,
      respiratory:false,

      limb:false,
      upper:false, 
      upper_left:false, 
      upper_left_hand_fingers:false,
      upper_left_arm:false,
      upper_right:false, 
      upper_right_hand_fingers:false,
      upper_right_arm:false,

      lower:false,
      lower_left:false, 
      lower_left_tankle:false,
      lower_left_leg:false,
      lower_right:false, 
      lower_right_tankle:false,
      lower_right_leg:false,
      other:false,
      other_specification:""

    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.symptom_onset;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          this.setState({
            email:response.email,
            neurostamp_id:response.neurostamp_id,
            modality_id:response.modality_id,
            field_data: response.field_data.symptom_onset
          })
          for(let item of response.data){
            if(item.field=='ONSETDT'){
              this.setState({
                date_of_symptom_onset:item.value?dayjs(item.value):null
              })
            }
            if(item.field=='HXGEN' && item.value==1){
              this.setState({
                generalized:true
              })
            }
            if(item.field=='HXBLB' && item.value==1){
              this.setState({
                bulbar:true
              })
            }
            if(item.field=='HXBLBSCH' && item.value==1){
              this.setState({
                bulbar_speech:true
              })
            }
            if(item.field=='HXBLBSW' && item.value==1){
              this.setState({
                bulbar_swallowing:true
              })
            }
            if(item.field=='HXAX' && item.value==1){
              this.setState({
                axial:true
              })
            }
            if(item.field=='HXAXNK' && item.value==1){
              this.setState({
                neck:true
              })
            }
            if(item.field=='HXAXTR' && item.value==1){
              this.setState({
                trunk:true
              })
            }
            if(item.field=='HXAXTRRP' && item.value==1){
              this.setState({
                respiratory:true
              })
            }
            if(item.field=='HXLI' && item.value==1){
              this.setState({
                limb:true
              })
            }
            if(item.field=='HXLIU' && item.value==1){
              this.setState({
                upper:true
              })
            }
            if(item.field=='HXLIUL' && item.value==1){
              this.setState({
                upper_left:true
              })
            }
            if(item.field=='HXLULHF' && item.value==1){
              this.setState({
                upper_left_hand_fingers:true
              })
            }
            if(item.field=='HXLULAR' && item.value==1){
              this.setState({
                upper_left_arm:true
              })
            }
            if(item.field=='HXLIUR' && item.value==1){
              this.setState({
                upper_right:true
              })
            }
            if(item.field=='HXLURHF' && item.value==1){
              this.setState({
                upper_right_hand_fingers:true
              })
            }
            if(item.field=='HXLURAR' && item.value==1){
              this.setState({
                upper_right_arm:true
              })
            }
            if(item.field=='HXLIL' && item.value==1){
              this.setState({
                lower:true
              })
            }
            if(item.field=='HXLILL' && item.value==1){
              this.setState({
                lower_left:true
              })
            }
            if(item.field=='HXLLLAFT' && item.value==1){
              this.setState({
                lower_left_tankle:true
              })
            }
            if(item.field=='HXLLLLG' && item.value==1){
              this.setState({
                lower_left_leg:true
              })
            }
            if(item.field=='HXLILR' && item.value==1){
              this.setState({
                lower_right:true
              })
            }
            if(item.field=='HXLLRAFT' && item.value==1){
              this.setState({
                lower_right_tankle:true
              })
            }
            if(item.field=='HXLLRLG' && item.value==1){
              this.setState({
                lower_right_leg:true
              })
            }
            if(item.field=='HXOT' && item.value==1){
              this.setState({
                other:true
              })
            }
            if(item.field=='HXOTSP'){
              this.setState({
                other_specification:item.value
              })
            }
          }
          
          this.setState({
            loading:false
          })
        }else{
          this.setState({loading:false})
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_symptom_onset: date,
    });
  };
  // step 1
  save_details = () => {
    if (!this.state.date_of_symptom_onset) {
      message.warning("Date of symptom onset is required");
      return;
    }
    
    let date_of_symptom_onset = dayjs(this.state.date_of_symptom_onset).format("MM/DD/YYYY");

    let field_data=this.state.field_data
    const uniqueNames = [...new Map(field_data.map(item => [item.field, item])).values()];
    let questions=[]
    for(let item of uniqueNames){
      if(item.field=='ONSETDT'){
        let obj={
          value:date_of_symptom_onset,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXGEN'){
        let obj={
          value:this.state.generalized==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXBLB'){
        let obj={
          value:this.state.bulbar==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXBLBSCH'){
        let obj={
          value:this.state.bulbar_speech==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXBLBSW'){
        let obj={
          value:this.state.bulbar_swallowing==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXAX'){
        let obj={
          value:this.state.axial==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXAXNK'){
        let obj={
          value:this.state.neck==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXAXTR'){
        let obj={
          value:this.state.trunk==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXAXTRRP'){
        let obj={
          value:this.state.respiratory==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLI'){
        let obj={
          value:this.state.limb==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLIU'){
        let obj={
          value:this.state.upper==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLIUL'){
        let obj={
          value:this.state.upper_left==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLULHF'){
        let obj={
          value:this.state.upper_left_hand_fingers==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLULAR'){
        let obj={
          value:this.state.upper_left_arm==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLIUR'){
        let obj={
          value:this.state.upper_right==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLURHF'){
        let obj={
          value:this.state.upper_right_hand_fingers==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLURAR'){
        let obj={
          value:this.state.upper_right_arm==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLIL'){
        let obj={
          value:this.state.lower==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLILL'){
        let obj={
          value:this.state.lower_left==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLLLAFT'){
        let obj={
          value:this.state.lower_left_tankle==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLLLLG'){
        let obj={
          value:this.state.lower_left_leg==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLILR'){
        let obj={
          value:this.state.lower_right==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLLRAFT'){
        let obj={
          value:this.state.lower_right_tankle==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXLLRLG'){
        let obj={
          value:this.state.lower_right_leg==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXOT'){
        let obj={
          value:this.state.other==true ? 1:0,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='HXOTSP'){
        let obj={
          value:this.state.other_specification,
          view_name:item.view_name,
          form:"Symptom Onset",
          field: item.field
        }
        questions.push(obj) 
      }
    }
    let params = {
      data: JSON.stringify(questions),
      step: speech_demographics_form_type.symptom_onset,
      action_type: this.props.is_update == true ? "update" : "insert",
      email:this.state.email,
      neurostamp_id:this.state.neurostamp_id,
      modality_id:this.state.modality_id,
    };
    this.setState({ loading: true });
    Bridge.demographics.speech
    .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(10);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Symptom Onset</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2 input-heading">
                Date of symptom onset:{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <DatePicker
                onChange={this.onChange}
                format={"MM/DD/YYYY"}
                value={this.state.date_of_symptom_onset}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              />
            </div>
            <div className="">
              <label className="input-heading mb-0">
                Site of Symptom Onset:
              </label>
            </div>
            <div className="form-group">
              <br/>
              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    checked={this.state.generalized}
                    onChange={(e)=>this.setState({generalized:e.target.checked})}
                  >Generalized
                  </Checkbox>
                </li>
                <div class="form-group mb-4 mt-3" data-field-oid="DMALSF06" data-field-name="new_field876880"><label class="form-label font-weight-bold mb-0" style={{fontWeight:"800"}}>__________________</label></div>
              </div>
              <br/>
              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    checked={this.state.bulbar}
                    onChange={(e)=>this.setState({
                      bulbar:e.target.checked, bulbar_speech:false, bulbar_swallowing:false
                    })}
                  >Bulbar
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.bulbar_speech}
                    disabled={this.state.bulbar==true ? false:true}
                    onChange={(e)=>this.setState({bulbar_speech:e.target.checked})}
                  >. . . Speech
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.bulbar_swallowing}
                    disabled={this.state.bulbar==true ? false:true}
                    onChange={(e)=>this.setState({bulbar_swallowing:e.target.checked})}
                  >. . . Swallowing
                  </Checkbox>
                </li>
                <div class="form-group mb-4 mt-3" data-field-oid="DMALSF06" data-field-name="new_field876880"><label class="form-label font-weight-bold mb-0" style={{fontWeight:"800"}}>___________________________</label></div>
              </div>

              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    checked={this.state.axial}
                    onChange={(e)=>this.setState({
                      axial:e.target.checked,
                      neck:false, trunk:false,respiratory:false
                    })}
                  >Axial
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.neck}
                    disabled={this.state.axial==true ? false:true}
                    onChange={(e)=>this.setState({neck:e.target.checked})}
                  >. . . Neck
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.trunk}
                    disabled={this.state.axial==true ? false:true}
                    onChange={(e)=>this.setState({trunk:e.target.checked,respiratory:false})}
                  >. . . Trunk
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.respiratory}
                    disabled={this.state.trunk==true ? false:true}
                    onChange={(e)=>this.setState({
                      respiratory:e.target.checked,
                    })}
                  >. . . . . . Respiratory
                  </Checkbox>
                </li>
                <div class="form-group mb-4 mt-3" data-field-oid="DMALSF06" data-field-name="new_field876880"><label class="form-label font-weight-bold mb-0" style={{fontWeight:"800"}}>___________________________</label></div>
              </div>

              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    checked={this.state.limb}
                    onChange={(e)=>this.setState({
                      limb:e.target.checked,
                      upper:false, 
                      upper_left:false, 
                      upper_left_hand_fingers:false,
                      upper_left_arm:false,
                      upper_right:false, 
                      upper_right_hand_fingers:false,
                      upper_right_arm:false,

                      lower:false,
                      lower_left:false, 
                      lower_left_tankle:false,
                      lower_left_leg:false,
                      lower_right:false, 
                      lower_right_tankle:false,
                      lower_right_leg:false,
                    })}
                  >Limb
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.upper}
                    disabled={this.state.limb==true ? false:true}
                    onChange={(e)=>this.setState({
                      upper:e.target.checked,
                      upper_left:false, 
                      upper_left_hand_fingers:false,
                      upper_left_arm:false,
                      upper_right:false, 
                      upper_right_hand_fingers:false,
                      upper_right_arm:false,
                    })}
                  >. . . Upper
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.upper_left}
                    disabled={this.state.upper==true ? false:true}
                    onChange={(e)=>this.setState({
                      upper_left:e.target.checked,
                      upper_left_hand_fingers:false,
                      upper_left_arm:false,
                    })}
                  >. . . . . Left
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.upper_left_hand_fingers}
                    disabled={this.state.upper_left==true ? false:true}
                    onChange={(e)=>this.setState({upper_left_hand_fingers:e.target.checked})}
                  >. . . . . . . Hand/Fingers
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.upper_left_arm}
                    disabled={this.state.upper_left==true ? false:true}
                    onChange={(e)=>this.setState({
                      upper_left_arm:e.target.checked,
                    })}
                  >. . . . . . Arm
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.upper_right}
                    disabled={this.state.upper==true ? false:true}
                    onChange={(e)=>this.setState({
                      upper_right:e.target.checked,
                      upper_right_hand_fingers:false,
                      upper_right_arm:false,
                    })}
                  >. . . . . Right
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.upper_right_hand_fingers}
                    disabled={this.state.upper_right==true ? false:true}
                    onChange={(e)=>this.setState({upper_right_hand_fingers:e.target.checked})}
                  >. . . . . . . Hand/Fingers
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.upper_right_arm}
                    disabled={this.state.upper_right==true ? false:true}
                    onChange={(e)=>this.setState({upper_right_arm:e.target.checked})}
                  >. . . . . . Arm
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.lower}
                    disabled={this.state.limb==true ? false:true}
                    onChange={(e)=>this.setState({
                      lower:e.target.checked,
                      lower_left:false, 
                      lower_left_tankle:false,
                      lower_left_leg:false,
                      lower_right:false, 
                      lower_right_tankle:false,
                      lower_right_leg:false,
                    })}
                  >. . . Lower
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.lower_left}
                    disabled={this.state.lower==true ? false:true}
                    onChange={(e)=>this.setState({
                      lower_left:e.target.checked,
                      lower_left_tankle:false,
                      lower_left_leg:false,
                    })}
                  >. . . . . Left
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.lower_left_tankle}
                    disabled={this.state.lower_left==true ? false:true}
                    onChange={(e)=>this.setState({lower_left_tankle:e.target.checked})}
                  >. . . . . . . Ankle/foot/toe
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.lower_left_leg}
                    disabled={this.state.lower_left==true ? false:true}
                    onChange={(e)=>this.setState({lower_left_leg:e.target.checked})}
                  >. . . . . . Leg
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.lower_right}
                    disabled={this.state.lower==true ? false:true}
                    onChange={(e)=>this.setState({
                      lower_right:e.target.checked,
                      lower_right_tankle:false,
                      lower_right_leg:false,
                    })}
                  >. . . . . Right
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.lower_right_tankle}
                    disabled={this.state.lower_right==true ? false:true}
                    onChange={(e)=>this.setState({lower_right_tankle:e.target.checked})}
                  >. . . . . . . Ankle/foot/toe
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.lower_right_leg}
                    disabled={this.state.lower_right==true ? false:true}
                    onChange={(e)=>this.setState({lower_right_leg:e.target.checked})}
                  >. . . . . . Leg
                  </Checkbox>
                </li>
                <div class="form-group mb-4 mt-3" data-field-oid="DMALSF06" data-field-name="new_field876880"><label class="form-label font-weight-bold mb-0" style={{fontWeight:"800"}}>___________________________</label></div>
              </div>

              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    checked={this.state.other}
                    onChange={(e)=>this.setState({other:e.target.checked,other_specification:""})}
                  >Other Please Specify:
                  </Checkbox>
                </li>
                <li>
                  {this.state.other == true && (
                    <input
                      type="text"
                      className="form-control mt-3"
                      placeholder="Please Specify"
                      value={this.state.other_specification}
                      onChange={(e)=>this.setState({other_specification:e.target.value})}
                    />
                  )}
                </li>
              </div>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                    // background: "#b3b3b3",
                    // cursor: "auto",
                  }}
                  className="submit-button"
                  onClick={() =>{
                    if(this.props.is_non_als_user==true){
                      this.props.set_active_step(7);
                    }else{
                      this.props.set_active_step(7);
                    }
                  }}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
